(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-games-by-tags.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-games-by-tags.js');
"use strict";

const {
  useEffect,
  useState
} = React;
const useGamesByTags = _ref => {
  let {
    game
  } = _ref;
  const mounted = React.useRef(true);
  const [loading, setLoading] = useState(true);
  const [games, setGames] = useState([]);
  useEffect(() => {
    mounted.current = true;
    const fetchAllGames = async () => {
      try {
        const {
          tags,
          type
        } = game;
        const allGames = await svs.eInstant.shared.util.fetchAllGames();
        const filteredGames = allGames.filter(_ref2 => {
          let {
            tags: gameTags
          } = _ref2;
          return gameTags.some(t => tags.includes(t));
        }).filter(_ref3 => {
          let {
            type: gameType
          } = _ref3;
          return gameType !== type;
        }).filter(svs.eInstant.util.validateGameConfig).sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)).sort((a, b) => {
          const aCommonTags = a.tags.filter(t => tags.includes(t)).length;
          const bCommonTags = b.tags.filter(t => tags.includes(t)).length;
          return bCommonTags - aCommonTags;
        }).slice(0, 6);
        mounted.current && setGames(filteredGames);
      } catch (e) {
        svs.eInstant.logger.error('Failed to fetch games', e);
      } finally {
        mounted.current && setLoading(false);
      }
    };
    fetchAllGames();
    return () => {
      mounted.current = false;
    };
  }, [game.url]);
  return {
    games,
    loading
  };
};
setGlobal('svs.eInstant.shared.hooks.useGamesByTags', useGamesByTags);

 })(window);